import styled, { css } from 'styled-components';
import { primary, borders, highlights } from 'styles/colors';

export const ChipRow = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 8px 0;
  flex-wrap: wrap;
`;

export const Chip = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100px;
  padding: 10px 0px;
  border-radius: 8px;
  border: 2px solid ${borders};
  background-color: #fff;
  cursor: pointer;
  flex-shrink: 0;
  font-family: inherit;
  text-transform: uppercase;
  font-size: 0.85em;
  font-weight: 500;
  color: #152934;
  transition: border-color 0.15s ease, background-color 0.15s ease;

  &:hover {
    border-color: ${primary};
  }
`;

export const DateChipStyled = styled(Chip)`
  ${({ isSelected }) =>
    isSelected &&
    css`
      border-color: ${primary};
    `}
`;

export const TimeChipStyled = styled(Chip)`
  flex-direction: row;

  ${({ isSelected }) =>
    isSelected &&
    css`
      background-color: ${highlights.primary};
      border-color: ${highlights.warning};
    `}

  &:hover {
    background-color: ${highlights.primary};
  }
`;

export const OtherChipStyled = styled(Chip)`
  border-style: dashed;
  color: #71828f;
`;

export const ChipLine1 = styled.span`
  font-size: 0.85em;
  font-weight: 600;
  color: #152934;
`;

export const ChipLine2 = styled.span`
  font-size: 0.75em;
  color: #9ca7b1;
  margin-top: 2px;
`;

export const EmptyMessage = styled.div`
  font-size: 0.85em;
  color: #9ca7b1;
  padding: 10px 0;
`;

export const TimezoneLabel = styled.div`
  margin-top: 10px;
  font-size: 13px;
  color: #666;
  font-weight: bold;
`;
